<template>
<div style="padding-top:-2px;margin-top:-2px;">
    <v-label><b>{{label}}</b></v-label>
    <s-select-generic 
        autocomplete 
        class="text" 
        itemtext="PrjDescriptionLong" 
        itemvalue="PrjID" 
        :disabled="disabled"
        id="PrjDescriptionLong" 
        :value="value" 
        :return-object="returnObject"
        @input="input($event)" 
        :config="config" 
        :full="full" 
        :autofocus="autofocus"
        :text="text" 
        :clearable="clearable"
        :noDefault="noDefault" 
        :add="add"
        @add="addEvent()"
        ref="selectProjects">
    </s-select-generic>
</div>
</template>

<script>
import _sProjectsService from "@/services/Logistics/LgsGenericExactusService";
export default {
    components: {
    },
    props: {
        autofocus: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: false,
        },
        value: null,
        text: {
            type: String,
            default: ""
        },
        label: {
            type: String,
            default: "Proyectos",
        },
        returnObject: {
            type: Boolean,
            default: false,
        },
        noDefault: {
            type: Boolean,
            default: false,
        },
        full: {
            type: Boolean,
            default: false,
        },
        add: {
            type: Boolean,
            default: false,
        },
        business: {
            type: Number,
            default: 1,
        },

    },
    watch: {

        value(value) {
            this.item = value;
        },
        business(){
            this.loadMain()
        }
    },
    methods: {
        load(item) {
            this.text = item.SupName
        },
        addEvent() {
            this.dialog = true;
        },
        input(val) {
            this.$emit("input", val);
        },

        loadMain(){
            this.config = {
            url: _sProjectsService.getProjects(),
            params: {
                search: '',
                requestID: this.$fun.getUserID(),
                business: this.business
            }
        }
        }

    },
    data: () => ({
        dialog: false,
        item: 0,
        val: '',
        items: [],
        config: {},
    }),

    created() {
        this.loadMain()
    } 
}
</script>
